{
  "version": 1,
  "games": [
    {
      "id": "tribute-cards",
      "name": "贡奴卡牌",
      "summary": "点一下抽一张任务卡，温和 / 暧昧 / 成人三档卡池，开局先选档位。",
      "cover": "/covers/tribute-cards.svg",
      "players": { "min": 1, "max": 8 },
      "adult": true,
      "route": "/g/tribute-cards",
      "status": "ready"
    },
    {
      "id": "aeroplane-chess",
      "name": "飞行棋（双人整活版）",
      "summary": "创建房间 → 发房间码 → 好友加入，实时掷骰、撞机、弹幕飘屏。",
      "cover": "/covers/aeroplane-chess.svg",
      "players": { "min": 2, "max": 2 },
      "adult": true,
      "route": "/g/aeroplane-chess",
      "status": "ready"
    }
  ]
}
